import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "smartLesson",
    title: "Smart Lesson",
    icon: require("./content-icon.svg"),
    category: "training",
    Viewer,
    Editor,
    Preview: Viewer
}